import React from 'react';
import classNames from 'classnames';

import styles from './AttentionMark.module.scss';

function AttentionMark({ className, ...remainingProps }) {
  return (
    <span
      className={classNames(styles.root, className)}
      {...remainingProps}
    >
      *
    </span>
  );
}

export default AttentionMark;
